module.exports = __webpack_public_path__ + "img/information-icon.5e4543d2.svg";